
// Mailchimp customer tags functionality
function passingPopupMcTags(ele, tagsId) {
  let checkboxStatus = document.getElementById(ele.id);
  let updateValue = checkboxStatus.getAttribute('data-tag')
  let tagsValue = document.getElementById(tagsId);
  if (checkboxStatus.checked) {
    tagsValue.value += ',' + updateValue;
  } else {
    let replaceValue = tagsValue.value.replace(',' + updateValue, '');
    tagsValue.value = replaceValue;
  }
}

// CDP tags functionality code goes here according to checkbox checked.
function passingPopupCdpMcTags(ele, tagsId) {
  if (theme.settings.enable_multi_tags) {
    let hiddenInput = document.getElementById(tagsId);
    let checkbox_Status = document.getElementById(ele.id);
    let update_tagValue = checkbox_Status.getAttribute('data-checkbox');
    if (checkbox_Status.checked && update_tagValue) {
      hiddenInput.value = hiddenInput.value + ',' + update_tagValue;
    } else {
      if (update_tagValue) {
        let tagsValues = hiddenInput.value;
        let newstringValue = tagsValues.replace(',' + update_tagValue, "");
        hiddenInput.value = newstringValue;
      }
    }
  } else {
    let checkboxStatus = document.getElementById(ele.id);
    let updateBothTag = checkboxStatus.getAttribute('data-both-checkbox')
    let updateSingleTag = checkboxStatus.getAttribute('data-single-checkbox')
    let tagsValue = document.getElementById(tagsId);
    if (checkboxStatus.checked) {
      let tagsValues = tagsValue.value;
      let newstring = tagsValues.replace(updateSingleTag, updateBothTag);
      tagsValue.value = newstring;
    } else {
      let tagsValues = tagsValue.value;
      let newstring = tagsValues.replace(updateBothTag, updateSingleTag);
      tagsValue.value = newstring;
    }
  }
}

// Custom form integration with MailChimp
document.getElementById('mc-popup-form').addEventListener('submit', function (event) {
  event.preventDefault(); // Prevent default form submission

  // Modify MailChimp form URL to JSON format
  let formUrl = theme.settings.mailchimp_form_url.replace("post", "post-json");

  // Serialize form data manually
  const formData = new FormData(this);
  const queryString = new URLSearchParams(formData).toString();

  // Generate a unique callback function name (like jQuery did)
  const callbackName = `jsonp_callback_${Date.now()}`;

  // Create the final URL with JSONP callback
  let finalUrl = `${formUrl}&${queryString}&c=${callbackName}`;

  const requiredInputs = document.querySelectorAll('#mc-popup-form input[data-required="true"]');
  const isInvalidForm = Array.from(requiredInputs).some(input => input.classList.contains('input-is-error'));

  // Create a JSONP script element
  if (!isInvalidForm) {
    const script = document.createElement("script");
    script.src = finalUrl;

    // Define the callback function dynamically
    window[callbackName] = function (res) {
      if (res.result === "success") {
        // Reset the form
        document.getElementById("mc-popup-form").reset();

        // Hide the subscription form and show the thank-you message
        document.getElementById('custom-hide-after-subs').style.display = 'none';
        document.getElementById('custom-thanks-msg').style.display = 'block';

        // Push event to Google Tag Manager’s dataLayer for analytics tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'gaEvent',
          'eventTrigger': 'Newsletter',
          'eventCategory': 'Form',
          'eventAction': 'Submit',
          'eventLabel': 'Newsletter Popup',
          'eventValue': undefined
        });
      }
      else if (res.result == "error") {
        const errorMessage = document.querySelector('.mce_popup_inline_error');
        if (errorMessage) {
          errorMessage.textContent = theme.settings.newsletter_error_blank;
          errorMessage.style.display = 'block';
          const emailInput = document.getElementById('popup-form-email');
          emailInput && emailInput.classList.add('popup-error-input');
        }
      }

      // Cleanup: Remove script tag & callback function after execution
      delete window[callbackName];
      script.remove();
    };

    // Handle script loading errors
    script.onerror = function () {
      console.error("MailChimp JSONP request failed.");
      delete window[callbackName];
      script.remove();
    };

    // Append script to the document to trigger JSONP request
    document.body.appendChild(script);
  } else {
    emailInputCheckHandler();
  }

});


// Mailchimp popup DOB field functionality goes here.
const dayInputPopup = document.getElementById("custom-birthday-day");
const monthInputPopup = document.getElementById("custom-birthday-month");

dayInputPopup.addEventListener("input", popupCloneInputValue);
monthInputPopup.addEventListener("input", popupCloneInputValue);

function popupCloneInputValue(event) {
  if (event.currentTarget.id == 'custom-birthday-day') {
    document.getElementById('custom-bday-day').value = event.currentTarget.value;
  }
  if (event.currentTarget.id == 'custom-birthday-month') {
    document.getElementById('custom-bday-month').value = event.currentTarget.value;
  }
}

//DWFT-4252 popup form validation code goes here
const emailInput = document.getElementById('popup-form-email');
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function showErrorMessage() {
  const errorMessage = document.querySelector('.mce_popup_inline_error');
  errorMessage.textContent = theme.settings.newsletter_error_msg;
  errorMessage.style.display = 'block';
  emailInput.classList.add('popup-error-input');
}
function removeErrorMessage() {
  const errorMessage = document.querySelector('.mce_popup_inline_error');
  if (errorMessage) {
    errorMessage.style.display = 'none';
  }
  emailInput.classList.remove('popup-error-input');
}

function emailInputCheckHandler() {
  if (emailInput.value.trim() === '') {
    let errorblankMessage = document.querySelector('.mce_popup_inline_error');
    errorblankMessage.textContent = theme.settings.newsletter_error_blank;
    errorblankMessage.style.display = 'block';
    emailInput.classList.add('popup-error-input');
  } else if (!isValidEmail(emailInput.value)) {
    showErrorMessage();
  } else {
    removeErrorMessage();
  }
}

emailInput.addEventListener('blur', () => {
  emailInputCheckHandler();
});